<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Waters Contracting</h1>
                <p>
                    Thanks for your interest it Waters Contracting.
                    We are located in Layton, Utah.
                    If you choose to contact us we will get back to you as soon as we can.
                </p>
                <ul style="text-align:left;">
                  <li>Phone: 801-546-0844</li>
                  <li>Email: paul@waterscontrating.com</li>
                  <li>Text: 801-546-0844</li>
                </ul>
                <img alt="Waters Contracting trailer" src="../assets/trailer.jpg" style="width:50%;"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Contact',
}
</script>